import { uploadVideoImage, uploadVideoMediaFile } from '@/utils/videoImageApi'

function pickExt(mime, fallback) {
  const m = String(mime || '').toLowerCase()
  if (m.includes('png')) return 'png'
  if (m.includes('jpeg') || m.includes('jpg')) return 'jpg'
  if (m.includes('webp')) return 'webp'
  if (m.includes('mp4')) return 'mp4'
  if (m.includes('webm')) return 'webm'
  return fallback || 'bin'
}

async function urlToDataUrl(url) {
  const u = url != null ? String(url).trim() : ''
  if (!u) return ''
  if (/^https?:\/\//i.test(u)) return u
  if (u.startsWith('data:')) return u
  try {
    const res = await fetch(u)
    const blob = await res.blob()
    return await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '')
      reader.onerror = () => reject(new Error('read failed'))
      reader.readAsDataURL(blob)
    })
  } catch (e) {
    return ''
  }
}

/**
 * 将 blob/dataURL 固化为可访问 URL（与对话工作流上传逻辑一致）
 * @param {string} url
 * @param {string} [title]
 */
export async function persistWorkflowUploadUrl(url, title = '') {
  const u = url != null ? String(url).trim() : ''
  if (!u) return ''
  if (/^https?:\/\//i.test(u)) return u

  const uploadDataUrlSmart = async (du) => {
    const s = du != null ? String(du).trim() : ''
    if (!s) return ''
    if (/^https?:\/\//i.test(s)) return s
    try {
      const b = await (await fetch(s)).blob()
      const mime = String(b.type || '')
      if (mime.startsWith('video/')) {
        const ext = pickExt(mime, 'mp4')
        const fn = `upload-${Date.now()}-${Math.random().toString(36).slice(2, 7)}.${ext}`
        return await uploadVideoMediaFile({ file: b, filename: fn, ...(title ? { title } : {}) })
      }
    } catch (e) {
      /* ignore */
    }
    return await uploadVideoImage({ image: s, ...(title ? { title } : {}) })
  }

  if (u.startsWith('blob:')) {
    try {
      const res = await fetch(u)
      const blob = await res.blob()
      const mime = String(blob.type || '')
      if (mime.startsWith('video/') || mime.startsWith('image/')) {
        const ext = pickExt(mime, mime.startsWith('video/') ? 'mp4' : 'png')
        const fn =
          (title && String(title).trim() ? String(title).trim().replace(/[^\w.\-]+/g, '_') : '') ||
          `upload-${Date.now()}-${Math.random().toString(36).slice(2, 7)}.${ext}`
        const persisted = await uploadVideoMediaFile({ file: blob, filename: fn, ...(title ? { title } : {}) })
        if (persisted) return persisted
      }
    } catch (e) {
      /* fall through */
    }
  }

  const dataUrl = await urlToDataUrl(u)
  const du = dataUrl != null ? String(dataUrl).trim() : ''
  if (!du) return ''
  if (/^https?:\/\//i.test(du)) return du
  try {
    const persisted = await uploadDataUrlSmart(du)
    if (persisted) return persisted
  } catch (e) {
    /* ignore */
  }
  return du
}
